import { Phone, MessageCircle, MapPin } from "lucide-react";
import {
    PHONE_NUMBER_DISPLAY,
    PHONE_NUMBER_TEL,
    buildWhatsAppLink,
    SERVICE_AREAS,
} from "../lib/contact";
import { SuryaLogoMark } from "./SuryaLogo";

const QUICK_LINKS = [
    { id: "home", label: "Home" },
    { id: "services", label: "Services" },
    { id: "fleet", label: "Fleet" },
    { id: "clientele", label: "Clientele" },
    { id: "about", label: "About" },
    { id: "contact", label: "Contact" },
];

export const Footer = () => {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };
    const year = new Date().getFullYear();

    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#0A0A0A] border-t border-white/10"
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
                {/* Brand */}
                <div className="md:col-span-5">
                    <div className="flex items-center gap-3 mb-5">
                        <SuryaLogoMark size={56} className="rounded-md shadow-md shrink-0" />
                        <div className="flex flex-col leading-none">
                            <span className="font-display text-xl text-white tracking-wide">
                                SURYA CRANE
                            </span>
                            <span className="font-body text-[10px] uppercase tracking-[0.25em] text-[#FFC107]">
                                Crane Services
                            </span>
                        </div>
                    </div>
                    <p className="font-body text-sm text-neutral-400 leading-relaxed max-w-md">
                        Crane rental, heavy lifting and industrial logistics
                        across Mumbai, Thane, Bhiwandi &amp; Wada. Trusted for
                        20+ years. On-call 24 / 7.
                    </p>

                    <div className="mt-6 flex flex-wrap gap-3">
                        <a
                            href={buildWhatsAppLink()}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp"
                            className="inline-flex items-center gap-2 bg-[#FFC107] hover:bg-[#E0A800] text-black font-body font-bold text-xs uppercase tracking-[0.2em] px-5 py-3 transition-all duration-200 hover:-translate-y-0.5"
                        >
                            <MessageCircle size={14} strokeWidth={2.5} />
                            WhatsApp
                        </a>
                        <a
                            href={`tel:${PHONE_NUMBER_TEL}`}
                            data-testid="footer-call"
                            className="inline-flex items-center gap-2 border border-white/20 hover:border-white text-white font-body font-bold text-xs uppercase tracking-[0.2em] px-5 py-3 transition-colors"
                        >
                            <Phone size={14} strokeWidth={2.5} />
                            {PHONE_NUMBER_DISPLAY}
                        </a>
                    </div>
                </div>

                {/* Quick links */}
                <div className="md:col-span-3">
                    <div className="font-body text-[11px] uppercase tracking-[0.3em] text-[#FFC107] mb-5">
                        Navigate
                    </div>
                    <ul className="flex flex-col gap-3">
                        {QUICK_LINKS.map((l) => (
                            <li key={l.id}>
                                <button
                                    type="button"
                                    onClick={() => scrollTo(l.id)}
                                    data-testid={`footer-link-${l.id}`}
                                    className="font-body text-sm text-neutral-300 hover:text-[#FFC107] transition-colors uppercase tracking-[0.15em]"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Service areas */}
                <div className="md:col-span-4">
                    <div className="font-body text-[11px] uppercase tracking-[0.3em] text-[#FFC107] mb-5">
                        Service Areas
                    </div>
                    <ul className="flex flex-col gap-3">
                        {SERVICE_AREAS.map((a) => (
                            <li
                                key={a}
                                className="flex items-center gap-2 font-body text-sm text-neutral-300"
                            >
                                <MapPin
                                    size={14}
                                    className="text-[#FFC107]"
                                    strokeWidth={2}
                                />
                                {a}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Bottom strip */}
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <p className="font-body text-xs text-neutral-500">
                        © {year} Surya Crane Service. All rights reserved.
                    </p>
                    <p className="font-body text-[11px] uppercase tracking-[0.25em] text-neutral-600">
                        Lift · Move · Build
                    </p>
                </div>
            </div>
        </footer>
    );
};
